export default __webpack_public_path__ + "static/media/spreadthelive.2945e711.webp";